"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.availableOverlays = exports.appearances = exports.overlays = void 0;

/*
Constants to be used for Card component
*/
var overlays = Object.freeze({
  NONE: "none",
  TOP: "top",
  CENTER: "center",
  BOTTOM: "bottom"
});
exports.overlays = overlays;
var appearances = Object.freeze({
  DEFAULT: "default",
  FRAMED: "framed",
  QUIET_AND_FRAMED: "quietAndFramed",
  QUIET: "quiet"
});
exports.appearances = appearances;
var availableOverlays = Object.freeze(Object.values(overlays));
exports.availableOverlays = availableOverlays;
var componentArgs = {
  className: {
    table: {
      disable: true
    }
  },
  children: {
    table: {
      disable: true
    }
  },
  twoColumns: {
    table: {
      disable: true
    }
  }
};
exports.componentArgs = componentArgs;